import React from 'react';
import T from 'prop-types';
import {RetentionBanner as RetentionBannerStyled} from 'routes/App/cashback/styles';

const formatNumber = (value) =>
  `${(value || 0).toLocaleString('en-US', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 1
  })}`;

const RetentionBanner = ({retentionMultiplier}) => {
  return (
    <RetentionBannerStyled>
      <div className='big'>{formatNumber(retentionMultiplier)}x</div>
      <div>
        <div className='title'>
          Cashback customers come back {formatNumber(retentionMultiplier)}x more
          often
        </div>
        <div className='desc'>
          Compared to customers who don&apos;t use cashback. More repeats = more
          revenue
        </div>
      </div>
    </RetentionBannerStyled>
  );
};

RetentionBanner.propTypes = {
  retentionMultiplier: T.number
};

RetentionBanner.defaultProps = {
  retentionMultiplier: 0
};

export default RetentionBanner;
